import { LOCALE_STORAGE_KEY, SUPPORTED_LANGUAGES, normalizeLocale } from '../i18n/languages';

export const USER_CHOSEN_KEY = 'i18n_user_chosen';
export const LANG_KEY = 'i18n_lang';

const VALID_LANG_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export function isRussianDomain(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
    return hostname.includes('sportprogress.ru') || hostname.includes('localhost');
}

function readSavedLanguage() {
    const saved =
        localStorage.getItem('sp_locale')
        || localStorage.getItem('i18nextLng')
        || localStorage.getItem(LANG_KEY)
        || localStorage.getItem(LOCALE_STORAGE_KEY);
    if (!saved || saved === 'undefined' || saved === 'null') return null;
    if (saved.toLowerCase().startsWith('pt')) return 'pt-BR';
    return normalizeLocale(saved);
}

function isValidLanguage(code) {
    const normalized = normalizeLocale(code);
    return normalized && VALID_LANG_CODES.includes(normalized);
}

export function getInitialLanguage() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const isRuDomain = isRussianDomain(hostname);
    const saved = readSavedLanguage();

    if (saved && isValidLanguage(saved)) return saved;
    return isRuDomain ? 'ru' : 'en';
}

export function initDomainLanguage() {
    if (typeof window === 'undefined') return;

    const hostname = window.location.hostname;
    if (isRussianDomain(hostname)) return;

    const userChosen = localStorage.getItem(USER_CHOSEN_KEY) === 'true';
    if (!userChosen) {
        localStorage.setItem(LANG_KEY, 'en');
    }
}
export function persistLanguageStorage(lang) {
    const code = normalizeLocale(lang);
    if (!code) return;

    localStorage.setItem(LANG_KEY, code);
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
    localStorage.setItem('sp_locale', code);
    localStorage.setItem('i18nextLng', code);
}

export function markUserLanguageChoice(lang) {
    const code = normalizeLocale(lang);
    if (!code) return;

    localStorage.setItem(USER_CHOSEN_KEY, 'true');
    persistLanguageStorage(code);
}

export function getFallbackLng() {
    if (typeof window === 'undefined') return 'ru';
    return isRussianDomain() ? 'ru' : 'en';
}

export function getDetectionOptions() {
    return {
        order: [],
        caches: [],
        lookupLocalStorage: false,
        lookupCookie: false,
        lookupSessionStorage: false,
        lookupQuerystring: 'lang',
        convertDetectedLanguage: (lng) => normalizeLocale(lng),
    };
}
